import { useQuery } from '@tanstack/react-query';
import { tokenErrorCodeOf, type TokenErrorCode } from '~/lib/magicLinkToken';

type LoadState<T> =
  | { status: 'loading' }
  | { status: 'loaded'; data: T }
  | { status: 'error'; code: TokenErrorCode };

export function useTokenLoadedOnce<T>(
  token: string | null,
  fetcher: (token: string) => Promise<T>
): LoadState<T> {
  const { data, error, isPending } = useQuery({
    queryKey: ['magicLinkToken', token],
    queryFn: () => fetcher(token as string),
    enabled: token != null,
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  if (token == null || isPending) {
    return { status: 'loading' };
  }
  if (error) {
    return { status: 'error', code: tokenErrorCodeOf(error) };
  }
  return { status: 'loaded', data };
}
